module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av262-5e9afffeeb0e5d5bce1c2155031c6a26.jpg";